document.addEventListener('DOMContentLoaded', () => {
  console.log('Page has finished loading!', window.location);
  // Your code here
  mapClick();
});

const mapClick = () => {
  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('datamaps-subunit')) {
      var country = `${window.location.origin}/category/` + event.target.__data__.properties.name.split(' ').join('').toLowerCase();
      if (typeof(event.target.dataset.info) !== 'undefined' && !event.target.dataset.info.includes('ccc')) {
        window.location.href = country;
      }
    }
  });
}
